import { Maestro_ConsultasAplicaciones } from './Maestro_ConsultasAplicaciones';
import { Maestro_ConsultasRoles } from './Maestro_ConsultasRoles';
import { Maestro_ConsultasUsuarios } from './Maestro_ConsultasUsuarios';
import { Maestro_ConsultasParametros } from 'src/app/models/generic/Maestro_ConsultasParametros';
import { Maestro_Consultas } from './Maestro_Consultas';
import { Maestro_CargasArchivos } from './Maestro_CargasArchivos';
import { Maestro_CargasArchivosRoles } from './Maestro_CargasArchivosRoles';
import { Maestro_CargasArchivosUsuarios } from './Maestro_CargasArchivosUsuarios';
import { Maestro_CargasArchivosCargaRecurrenteArchivos } from './Maestro_CargasArchivosCargaRecurrenteArchivos';

export class Maestro_CargasArchivos_Actualizacion {
    principal: Maestro_CargasArchivos;
    listaRoles: Maestro_CargasArchivosRoles[];
    listaUsuarios: Maestro_CargasArchivosUsuarios[];
    listaCargasRecurrencia: Maestro_CargasArchivosCargaRecurrenteArchivos[];
    listaCargasRecurrenciaEliminar: Maestro_CargasArchivosCargaRecurrenteArchivos[];
}
